import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import { useTranslation } from 'react-i18next';
import useGeneratePdfFromContent from '../../../hooks/useGeneratePdfFromContent';

type PdfDownloadButtonProps = {
  contentId: string;
  documentId: string;
  fileName: string;
};

const PdfDownloadButton = ({ contentId, documentId, fileName }: PdfDownloadButtonProps) => {
  const { t } = useTranslation();
  const { generatePdf, isLoading } = useGeneratePdfFromContent();

  const downloadPdf = async () => {
    await generatePdf({ contentId, documentId, fileName });
  };

  return isLoading ? (
    <Button variant="text" disabled>
      <CircularProgress size={24} />
    </Button>
  ) : (
    <Button onClick={downloadPdf} variant={'text'}>
      {t('download')}
    </Button>
  );
};

export default PdfDownloadButton;
